import { getMetricFromResidentialLevels as r } from "../index6.js";
import { getLevelGrossFacadeArea as t } from "../level-metrics/index22.js";
const s = (e) => r(e, t);
export {
  s as getResidentialGrossFacadeArea
};
//# sourceMappingURL=index48.js.map
